<div class="all-filters-wrapper">
    <div class="all-filters" *ngIf="allFilters">
        <div class="filter-group" *ngFor="let filter of allFilters">
            <div class="group-label">
                <span class="label">{{filter.label}}</span>
                <finder-icon-tooltip *ngIf="filter.toolTipText && !isSafari"
                    class="tooltip"
                    name="information"
                    size="s"
                    [tooltip]="filter.toolTipText">
                </finder-icon-tooltip>
                <span class="tooltip-label" *ngIf="filter.toolTipText && isSafari">{{filter.toolTipText}}</span>
            </div>
            <div class="facet-groups">
                <div class="facet-group" *ngFor="let facetGroup of filter.facetGroups">
                    <div *ngIf="facetGroup.label" class="label">{{facetGroup.label}}</div>
                    <div class="facets">
                        @defer {
                            <finder-ra-checkbox
                                class="checkbox"
                                *ngFor="let facet of facetGroup.facets"
                                alignment="top"
                                [checked]="facet.value"
                                (checkedChanged)="onCheck($event, facet)">
                                {{facet.label}}
                                <div class="description" *ngIf="facet.description">
                                    {{facet.description}}
                                </div>
                            </finder-ra-checkbox>
                        }
                    </div>
                </div>
            </div>
            <finder-button anchor="true" class="show-more-filters"
                *ngIf="filter.showMoreModal"
                (click)="filter.showMoreModal.open()"
            >
                {{ showMoreLabel }}
            </finder-button>
        </div>
    </div>
    <finder-height-slider
        *ngIf="enableHeightFilter"
        showCheckbox="true"
        [heightLabel]="heightLabel">
    </finder-height-slider>
</div>
